import { render } from "./MarketSimpleBook.vue?vue&type=template&id=5dd7e106"
import script from "./MarketSimpleBook.vue?vue&type=script&lang=js"
export * from "./MarketSimpleBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__